import { useState, useContext } from 'react';
import { Toolbar, Box } from '@mui/material';
import { Appbar, Sidebar } from '../components/Menu';
import { useSidebar } from '../context/SidebarContext';
import { AuthContext } from '../context/AuthContext';

const OPEN_DRAWER_WIDTH = 300;
const COLLAPSED_DRAWER_WIDTH = 65;

export const MainLayout = ({ title, children }) => {

  const [mobileOpen, setMobileOpen] = useState(false);
  const { abierto, toggleSidebar } = useSidebar();
  const { user } = useContext(AuthContext);

  const currentDrawerWidth = abierto
    ? OPEN_DRAWER_WIDTH
    : COLLAPSED_DRAWER_WIDTH;

  const shouldHideSidebar = user?.idPerfil === 2;
  const mainWidth = shouldHideSidebar ? '100%' : `calc(100% - ${currentDrawerWidth}px)`;
  const mainMargin = shouldHideSidebar ? '0' : `${currentDrawerWidth}px`;

  const onDrawerToggle = () => {
    setMobileOpen(prev => !prev);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Appbar
        title={title}
        drawerWidth={shouldHideSidebar ? 0 : currentDrawerWidth}
        onDrawerToggle={onDrawerToggle}
      />

      <Sidebar
        drawerWidth={OPEN_DRAWER_WIDTH}
        mobileOpen={mobileOpen}
        onDrawerToggle={onDrawerToggle}
        recalcularAnchoDrawer={toggleSidebar}
        abierto={abierto}
      />

      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          p: 2,
          transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
          width: { sm: mainWidth },
          ml: { sm: mainMargin },
        })}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};
